function showRequestQuoteModal () {

	$('body').lpModal({
		onInit: true,
		width: 574,
		height: 825,
		src: `/wish-list/RequestQuote/${lp.wishlist.wishlistToken}`
	});

}

export default showRequestQuoteModal;
